import { notification } from 'ant-design-vue';

import i18n from '@/i18n';

const notifications = {
  error(description, title = i18n.t('common.error')) {
    return notification.error({
      message: title,
      description,
    });
  },
  success(description, title = i18n.t('common.success')) {
    return notification.success({
      message: title,
      description,
    });
  },
  warning(description, title = i18n.t('common.warning')) {
    return notification.warning({
      message: title,
      description,
    });
  },
};

export default {
  install(Vue) {
    /* eslint-disable-next-line no-param-reassign */
    Vue.prototype.$notifications = notifications;
  },
};
